import { useEffect, useRef } from 'react';
export var useCreateNode = function useCreateNode(container, hideNode) {
  if (container === void 0) {
    container = document.body;
  }

  var defaultNode = useRef(null);
  useEffect(function () {
    // Unmount the created node.
    if (hideNode) {
      return;
    }

    var node = document.createElement('div');
    node.setAttribute('data-test', 'node');
    defaultNode.current = node;
    container.appendChild(defaultNode.current);
    return function () {
      if (defaultNode.current) {
        container.removeChild(defaultNode.current);
        defaultNode.current = null;
      }
    };
  }, [container, hideNode]);
  return defaultNode.current;
};